import MarketProfile from "./marketProfile";
import { useTranslation } from "../../../../i18n/useTranslation";

const MarketGlobal = () => {
  const { t } = useTranslation();
  return (
    <MarketProfile
      tag="Parent · Global"
      name="Tapaswe Global"
      intro={t("marketsGlobal.intro")}
      offices={[{ label: "", address: "Mumbai, Maharashtra, India" }]}
      solutionsNote={t("marketsGlobal.solutionsNote")}
      leadershipLabel={t("marketProfile.executiveLeadership")}
      ceo="Nalin Tewari — Chief Trust Officer"
      ceoLinkedIn="https://www.linkedin.com/in/nalintewari"
    />
  );
};

export default MarketGlobal;
